/* Palo Alto - custom JS. See project docs 4-5 Sept 2026 for background. */
(function () {

  /* 1. SWEDEN (SEK) PRICE FIX - 4 Sept 2026
     Palo Alto's formatMoney() handles only four money tokens; Sweden's is
     {{amount_with_space_separator}}, so SEK pages rendered a bare " SEK".
     Swap to a token the theme handles, then restore the space separator.
     No-ops unless the market uses that token (today: Sweden only). */
  (function swedishPriceFix() {
    var t = window.theme;
    if (!t) return;
    var TOKEN = 'amount_with_space_separator';
    var mf = t.moneyFormat || '', mwc = t.moneyWithCurrencyFormat || '';
    if (mf.indexOf(TOKEN) === -1 && mwc.indexOf(TOKEN) === -1) return;

    t.moneyFormat = mf.replace(TOKEN, 'amount_with_comma_separator');
    t.moneyWithCurrencyFormat = mwc.replace(TOKEN, 'amount_with_comma_separator');

    var GROUPED = /(\d)\.(?=\d{3}(?:\D|$))/g;
    var SEL = '[data-product-price],[data-compare-price],[data-price-off-amount],[data-cart-item-price],[data-cart-price],[data-subtotal],[data-money]';

    function tidy(el) {
      if (el.children.length) return;
      var s = el.textContent;
      if (s.indexOf('.') === -1) return;
      var f = s.replace(GROUPED, '$1 ');
      if (f !== s) el.textContent = f;
    }
    var queued = false;
    function sweep() { queued = false; var n = document.querySelectorAll(SEL); for (var i = 0; i < n.length; i++) tidy(n[i]); }
    function schedule() { if (queued) return; queued = true; setTimeout(sweep, 0); }
    function start() {
      sweep();
      if (!window.MutationObserver || !document.body) return;
      new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true, characterData: true });
      window.addEventListener('load', schedule);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();


  /* 2. MOBILE GALLERY SWIPE DOTS - 5 Sept 2026
     The theme starts Flickity with pageDots off and hides the arrows on
     mobile, so the thumbnail strip was the only cue that more photos exist.
     That strip is now hidden to lift the buy button above the fold, so this
     replaces the cue with dots overlaid on the image (no layout cost).

     IMPORTANT: the dots are appended to .product-single__gallery, NOT to the
     slider. Appending inside .product-single__media-slider makes Flickity
     adopt the element as an extra cell - it gets translateX(400%) and the
     carousel gains a blank fifth slide. The gallery wrapper is position
     relative and outside Flickity's control, so it is the safe anchor.

     Indicator only - the interaction is the swipe. */
  (function galleryDots() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 768px)');
    var wrap, dots = [];

    function slides() { return document.querySelectorAll('.product-single__media-slide'); }

    function build() {
      var gallery = document.querySelector('.product-single__gallery');
      var slider = document.querySelector('.product-single__media-slider');
      var s = slides();
      if (!gallery || !slider || wrap || s.length < 2) return;

      wrap = document.createElement('div');
      wrap.className = 'st-gallery-dots';
      wrap.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < s.length; i++) {
        var d = document.createElement('span');
        d.className = 'st-gallery-dots__dot';
        wrap.appendChild(d);
        dots.push(d);
      }
      gallery.appendChild(wrap);   // NOT slider - see note above
      sync();

      new MutationObserver(function () { setTimeout(sync, 0); })
        .observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    function sync() {
      var s = slides();
      for (var i = 0; i < dots.length && i < s.length; i++) {
        dots[i].classList.toggle('is-active', s[i].classList.contains('is-selected'));
      }
    }

    function teardown() { if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); wrap = null; dots = []; }
    function apply() { if (mq.matches) build(); else teardown(); }
    function init() { apply(); if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();


  /* 3. STICKY ADD TO CART - REMOVED 5 Sept 2026.

     Built 4 Sept when the real Add to Cart button sat 972px down the page and
     was effectively unreachable on a phone. The above-the-fold work in
     assets/mobile-pdp.css then moved the button to 737-780px, which is on
     screen from the start on a 812px phone and one flick (113px) away on a
     667px one - so the bar was duplicating a button the shopper could already
     see, and announcing itself at the moment they scrolled past it.

     It also caused two live faults in a day: it bound itself to grid quick-buy
     buttons once quick buy was enabled, and it covered the cart drawer's
     Checkout button.

     Removed on Michael's call. The fold fix is what solved the original
     problem; this was belt-and-braces that cost more than it returned. The
     matching CSS has gone from assets/mobile-pdp.css. If it is ever wanted
     back, the project doc "Mobile PDP v2 - fixes from handset testing" and
     the deep-scroll variant on theme 186093109626 have the full code. */


  /* 4. BASKET "ADD TO YOUR ORDER" ROW - 3 Oct 2026
     Markup: snippets/st-upsell-row.liquid (rendered inside the basket's
     upsell area, so the theme re-renders it after every basket change).
     a) tidy(): drops cards over GBP 100 converted at Shopify's rate, keeps the
        first 6 and un-hides the row. Re-runs whenever the basket re-renders.
     b) "+ Add": POST /cart/add.js, then ask the theme to refresh the drawer
        (theme:cart:refresh). If the new line has not appeared ~1.5s later the
        page reloads, so the basket is never left out of date. The cart page
        always reloads. */
  (function stUpsell() {
    var CAP_GBP_PENCE = 10000, MAX = 6;
    function rate() { return parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; }
    function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

    function tidy() {
      var rows = document.querySelectorAll('[data-st-upsell]:not([data-st-ready])');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i], cap = CAP_GBP_PENCE * rate(), shown = 0;
        row.setAttribute('data-st-ready', '');
        var cards = row.querySelectorAll('[data-st-upsell-card]');
        for (var j = 0; j < cards.length; j++) {
          var p = parseFloat(cards[j].getAttribute('data-price')) || 0;
          if (p > cap * 1.005 || shown >= MAX) cards[j].parentNode.removeChild(cards[j]);
          else shown++;
        }
        if (shown) row.hidden = false; else row.parentNode.removeChild(row);
      }
    }
    var queued = false;
    function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; tidy(); }, 0); }

    function lineShown(id) { return !!document.querySelector('[data-item^="' + id + ':"]'); }

    function refreshRow(card) {
      var holder = card.closest('[data-pair-products-holder]');
      if (!holder) return;
      fetch(root() + '?section_id=api-cart-items', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var up = doc.querySelector('[data-api-upsell-items]');
          if (up) holder.innerHTML = up.innerHTML;
        })
        .catch(function () {});
    }

    function added(card, id) {
      if (card.closest('[data-cart-page]')) { window.location.reload(); return; }
      try {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      } catch (e) {}
      setTimeout(function () {
        if (!lineShown(id)) { window.location.reload(); return; }
        if (card.isConnected) refreshRow(card);
      }, 1500);
    }

    function onClick(e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-st-upsell-add]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var card = btn.closest('[data-st-upsell-card]');
      var sel = card && card.querySelector('[data-st-upsell-size]');
      var id = sel ? sel.value : btn.getAttribute('data-variant-id');
      var err = card && card.querySelector('[data-st-upsell-error]');
      if (!id) return;
      btn.disabled = true;
      if (err) err.hidden = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { added(card, id); })
        .catch(function (j) {
          btn.disabled = false;
          if (err) { err.textContent = (j && (j.description || j.message)) || 'Sorry, that could not be added.'; err.hidden = false; }
        });
    }

    function init() {
      document.addEventListener('click', onClick);
      tidy();
      if (window.MutationObserver && document.body) {
        new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

})();